<template>
    <div>
       <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
      <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab"> Mis Prestamos</b-card-header>
      <b-card-body>

      <div class="row" v-show="model.NoTieneCredito">
           
           <div class="col-md-12" style="padding:15px;text-align:center;">
           <img :src="getImgUrl(model.ImagenNoTieneCreditos)" :alt="model.ImagenNoTieneCreditos" width="120px">
           </div>

           <div class="col-md-12" style="text-align:center;">
             <span> {{model.TextoNoTieneCreditos}}</span>
             </div>
      </div>

      <div v-show="!model.NoTieneCredito" v-for="(item,index) in misPrestamos" 
                    @click="miPrestamoItemClicked(item)"
                    v-bind:key="index">
                    <div class="row" style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0">
                        <div class="col-10">
                            <div class="row">
                                <div class="col-12 contact-item-name h2">
                                    <span>Préstamo Nro.: {{item.CreditoFormateado}}</span>
                                </div>
                            </div>
                             <div class="row">
                                <div class="col-1" >
                                   <img :src="getImgUrl(item.ImagenEstado)" :alt="item.ImagenEstado" width="60px">
                                </div>
                                <div class="col-6">
                                      <div class="row">
                                        <span>{{item.DescripcionProductoCredito}}</span>
                                    </div>
                                    <div class="row h3" style="color:green;">
                                        <span>{{item.NombreEstado}}</span>
                                    </div>
                                    <div class="row">
                                        <span>{{item.FechaProximaCuotaFormateada}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-2 text-right mt-4"></div>
                    </div>
      </div>
   </b-card-body>
    </b-card> 
  </div>
</template>
<style>

</style>
<script>

  import axiosHelpers from '@/helpers/axiosHelpers';
  export default {
      name: "misprestamos",
      props: {
        
      },
      data(){
            return{
                model: {   
                        NoTieneCredito:false,
                        ImagenNoTieneCreditos:"",
                        TextoNoTieneCreditos:""
                },
                misPrestamos: [],
            }
        },
       
        methods: {
            getImgUrl(pic) {
              if (pic.substring((pic.length-4),(pic.length)) == ".png"){
                    return "/img/"+pic;

                }
                else{
                    return "/img/"+pic+".png";
                }
            },
            
            miPrestamoItemClicked(prestamo){
                let context = this;
                if(prestamo.MostrarDetalle){
                        context.$router.push({ name: "miprestamoPersonal", params: 
                        { 
                            imagenEstado: prestamo.ImagenEstado,
                            descripcionProductoCredito:prestamo.DescripcionProductoCredito,
                            nombreEstado: prestamo.NombreEstado,
                            fechaProximaCuotaFormateada: prestamo.FechaProximaCuotaFormateada,
                            monto: prestamo.FormattedAmount,
                            fechaAcreditacion: prestamo.FechaAcreditacionForamteada,
                            valorCuota: prestamo.ValorCuotaFormateada,
                            tna:prestamo.TnaFormateado,
                            cft:prestamo.CFTFormateado
                

                        }});    
                }

            }
        },
        computed:{
           
        },
        beforeMount: function() {
            let context = this;
             axiosHelpers.axiosPost("CreditoWenance/ObtenerMisCreditos", {}, this, function(data) {                 
                context.misPrestamos = data.ResponseVM.Items;
                context.model.NoTieneCredito=data.ResponseVM.Items.length == 0 ;
                context.model.ImagenNoTieneCreditos=data.ResponseVM.ImagenNoTieneCreditos;
                context.model.TextoNoTieneCreditos=data.ResponseVM.TextoNoTieneCreditos;
                console.log(context.model.NoTieneCredito);
            });
        }
  }

</script>